import { createFileRoute } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../../../../components/shared/page-components/LoadingPage';
import IntegrationPageContainer from '../../../../../../components/subledger-integrations/IntegrationPageContainer';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/integrations/$integrationId',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: IntegrationPageContainer,
});
